<form [formGroup]="bugReportForm" (ngSubmit)="onSubmit()" style="min-width: 50vw; height: auto">
  <h1>Create new Bug</h1>

  <div id="form-container">
    <div style="flex-direction: row; display: flex; width: 100%">
      <fieldset style="width: 70%" class="box" id="bugTitleBox">
        <legend>Title</legend>
        <span>
          <input required (focusout)="checkValidity()" id="bugTitle" formControlName="title" placeholder="Enter title..." />
        </span>
      </fieldset>
      <fieldset class="box" style="width: 30%">
        <legend>Priority:</legend>
        <mat-select id="priority" formControlName="priority" panelClass="panel" disableOptionCentering>
          <mat-option value="lowPriority" selected>low</mat-option>
          <mat-option value="mediumPriority">medium</mat-option>
          <mat-option value="highPriority">high</mat-option>
        </mat-select>
      </fieldset>
    </div>
    <div style="width: 100%; display: inline-block; margin-top: 10px">
      <textarea id="text" rows="5" formControlName="text" class="box" style="width: 100%; margin: 0"></textarea>
    </div>
    <div style="float: right; margin-right: 0">
      <span style="display: block; overflow: hidden">
        <input id="reporter" type="text" formControlName="reporter" readonly />
      </span>
    </div>
  </div>
  <mat-dialog-actions>
    <button type="submit" id="submit" class="green-button">Add new Bug</button>
    <button type="button" id="cancel" mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</form>
